"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _CmeOrganization = _interopRequireDefault(require("../../factories/CmeOrganization.js"));
var _createReducer = _interopRequireDefault(require("../../helpers/createReducer.js"));
var _constants = require("../../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var initialState = exports.initialState = (0, _immutable.Map)({
  isSearching: false,
  sendEmailStatus: null,
  isSendingEmail: false,
  organizations: (0, _immutable.List)(),
  productPageIds: (0, _immutable.List)(),
  searchedSpecialtyId: null,
  searchedStateId: null
});
var reducers = {};
reducers[_constants.CME_COACH_SEARCHING] = function cmeCoachSearching(state, payload) {
  var selectedSpecialtyId = payload.selectedSpecialtyId,
    selectedStateId = payload.selectedStateId;
  return state.set('isSearching', true).set('searchedStateId', selectedStateId).set('searchedSpecialtyId', selectedSpecialtyId);
  // Uncomment these lines to remove results between searches
  // .set('organizations', List())
  // .set('productPageIds', List());
};

reducers[_constants.CME_COACH_SEARCHED] = function cmeCoachSearched(state, payload) {
  var organizations = payload.data.map(function (json) {
    return new _CmeOrganization.default(json);
  });
  var productPageIds = payload.included.filter(function (record) {
    return record.type === 'product_page';
  }).map(function (record) {
    return parseInt(record.id);
  });
  return state.set('isSearching', false).set('organizations', (0, _immutable.List)(organizations)).set('productPageIds', (0, _immutable.List)(productPageIds));
};
reducers[_constants.CME_COACH_SENDING_EMAIL] = function cmeCoachSendingEmail(state) {
  return state.set('isSendingEmail', true).set('sendEmailStatus', null);
};
reducers[_constants.CME_COACH_SENT_EMAIL] = function cmeCoachSentEmail(state, payload) {
  return state.set('isSendingEmail', false).set('sendEmailStatus', !!payload.sendEmailStatus);
};
var _default = exports.default = (0, _createReducer.default)(reducers, initialState);